import { TextareaField } from "components/Common/input-fields"
import Notify from "components/Common/notify"
import { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import Select from "react-select"
import { Card, CardBody, CardFooter, CardTitle, Col, Row } from "reactstrap"
import { SHUK_AUTH_PORTAL_TOKEN, SHUK_ROLE_VIWEWER } from "redux/enums"
import {
  allApplications,
  AssignStaff,
  GetApplicationComments,
  SendApplicationComment,
  UpdateAssignStaff,
} from "redux/slice/applications/applicationSlice"
import {
  allApplicationRecommendations,
  GetApplicationRecommendation,
  SendApplicationRecommendation,
} from "redux/slice/recommendation/recomendationSlice"
import { allStaffs, StaffFetch } from "redux/slice/staff/staffSlice"
import { DateFormater, DateTimeFormatter } from "utilities/dateformater"
import { parseJwt } from "utilities/parse-jwt"

export default function ApplicationRecommendation({userRole}) {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { currentApplicationSelected } = useSelector(allApplications)
  const { applicationRecommendations } = useSelector(
    allApplicationRecommendations,
  )

  const [recommendation, setRecommendation] = useState("")

  const isViewer = userRole === SHUK_ROLE_VIWEWER

  useEffect(() => {
    if (
      currentApplicationSelected &&
      Object.keys(currentApplicationSelected)?.length > 0 &&
      currentApplicationSelected?.id
    ) {
      dispatch(GetApplicationRecommendation(currentApplicationSelected?.id))
    }
  }, [currentApplicationSelected])
  console.log("recommendation loading......", applicationRecommendations)

  const handleSendRecommendation = async () => {
    let dateTime = new Date().toISOString()
    const token = localStorage.getItem(SHUK_AUTH_PORTAL_TOKEN)
    if (!recommendation) {
      Notify("error", "Please write recommendation first.")
    } else if (!token) {
      Notify("error", "Please login first.")
      navigate("/login")
    } else if (
      !currentApplicationSelected ||
      Object.keys(currentApplicationSelected)?.length === 0
    ) {
      Notify("error", "No application selected.")
    } else {
      let userId = await parseJwt(token)
      let recommendationsData = {
        StaffId:
          userId?.[
            "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"
          ],
        studentId: currentApplicationSelected?.id,
        recommendationData: {
          comments: recommendation,
          time: dateTime,
        },
      }
      dispatch(SendApplicationRecommendation(recommendationsData))
        .then(resp => {
          console.log(
            "response of sending recommendation in application",
            resp?.payload,
          )
          if (resp?.payload?.status === 200) {
            // handleCommentsModal();
            dispatch(
              GetApplicationRecommendation(currentApplicationSelected?.id),
            )
            Notify("success", "recommendation sent.")
            setRecommendation("")
          }
        })
        .catch(err => {
          console.log("Error sending recommendation", err)
        })
      console.log("new recommendations data", recommendationsData)
    }
  }

  return (
    <Card className="bg-white application-comments-container">
      <CardBody className="mt-2 comments-body">
        <CardTitle tag="h3" style={{ color: "#1140db" }} className="fs-3">
          Recommendations
        </CardTitle>
        <div>
          {applicationRecommendations?.length > 0 ? (
            [...applicationRecommendations].reverse().map((rec, index) => (
              <div
                className="comment-box"
                style={{ borderColor: "#1140db" }}
                key={index}
              >
                <h5 className="recommend-author-name">{rec?.authorName}</h5>
                <p
                  className="comment-para"
                  style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                >
                  {rec?.comments}
                </p>
                <p className="recommend-date">{DateTimeFormatter(rec?.time)}</p>
              </div>
            ))
          ) : (
            <p className="text-center fs-4 mt-4 text-muted">
              No recommendations yet
            </p>
          )}
        </div>
      </CardBody>
      {
        !isViewer && (
          <CardFooter className="recommend-footer">
            <div className="">
              <TextareaField
                label=""
                className="mb-2"
                compulsory={false}
                disabled={false}
                rows="6"
                value={recommendation}
                placeholder="Enter Recommendation"
                onChange={e => setRecommendation(e.target.value)}
              />
              <button
                className="btn d-flex justify-content-between"
                style={{
                  width: "150px",
                  backgroundColor: "#1140db",
                  color: "#fff",
                  justifySelf: "end",
                }}
                onClick={handleSendRecommendation}
              >
                Recommend
                <i className="mdi mdi-send float-end"></i>
              </button>
            </div>
          </CardFooter>
        )
      }
    </Card>
  )
}
